import classes from './Newsroom.module.scss';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';

export default function Newsroom(props) {
    const router = useRouter();
    /**
     * return null needed for react render func
     */
    if (!props) return null;

    const { site_header } = props[0];
    const { date, image, icon_title, article_link, content } = props[1];
    const { url, alternativeText, height, width } = image?.data?.attributes;

    return (
        <>
            {props.isSection && (
                <div className={`${classes.oRow} row`}>
                    <h2 className={`aSectionTitle _accent col fntH2`}>{site_header}</h2>
                </div>
            )}
            <div className={classes.oNewsroom}>
                <div className={classes.oSectionBody}>
                    <div className={`container`}>
                        <div className={`row`}>
                            <figure className={`${classes.mSectionImage} col-12 col-md-6`}>
                                <Image
                                    src={url}
                                    alt={alternativeText}
                                    height={height}
                                    width={width}
                                    className={classes.aImage}
                                    aria-hidden="true"
                                    layout="responsive"
                                />
                            </figure>
                            <div className={`${classes.mSectionBody} col-12 col-md-6`}>
                                <div className={`${classes.mArticleMeta} row no-gutters`}>
                                    <div className={`${classes.aAyobaLogo} col-md-6`}>
                                        <figure className={classes.mImage}>
                                            <Image
                                                src={`/web/content/icon-ayoba.png`}
                                                alt={``}
                                                width={`28`}
                                                height={`28`}
                                                className={classes.aImage}
                                                layout="fixed"
                                                aria-hidden="true"
                                            />
                                        </figure>
                                        <span className={`${classes.aLogoText} fnt25f fnt-xb`}>
                                            {icon_title}
                                        </span>
                                    </div>
                                    <div className={`${classes.mDate} col-md-6 fnt16f`}>{date}</div>
                                </div>
                                <h3 className={`${classes.aTitle} fnt30 fnt-b fontRTL widthRTL`}>
                                    <span className={classes.first}>{content.site_header}</span>
                                </h3>
                                <div className={`${classes.mTextBlock} fnt18f fontRTL`}>
                                    <p>{content.site_description}</p>
                                </div>
                                <div className={classes.ctaWrapper}>
                                    <Link
                                        href={{
                                            pathname: `articles/${article_link.href}`,
                                            query: `lang=${
                                                router.query?.lang || router.defaultLocale
                                            }`
                                        }}
                                    >
                                        <a
                                            className={`${classes.aTextLink} aTextLink fnt18f fnt-xb`}
                                        >
                                            {article_link.label}
                                        </a>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
